import { render } from "./IconHeart.vue?vue&type=template&id=f16c3246&ts=true"
import script from "./IconHeart.vue?vue&type=script&lang=ts"
export * from "./IconHeart.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__